/**
 * Daten im Gerät für die Nutzung ohne Netz: Videos gezielt speichern und
 * beim Abmelden alles wieder entfernen. Bilder und Rezepte speichert der
 * Service Worker von selbst (siehe vite.config.ts, runtimeCaching).
 */

/** Name des Medienspeichers im Service Worker. */
export const MEDIA_CACHE = 'kochbuch-medien';

/** Name des Datenspeichers im Service Worker. */
export const DATA_CACHE = 'kochbuch-daten';

/** Gibt es den Cache-Speicher in diesem Browser? */
export function offlineStorageAvailable(): boolean {
  return typeof window !== 'undefined' && 'caches' in window;
}

/** Sind alle Dateien bereits im Gerät? */
export async function allCached(urls: readonly string[]): Promise<boolean> {
  if (!offlineStorageAvailable() || urls.length === 0) {
    return false;
  }
  const cache = await window.caches.open(MEDIA_CACHE);
  const hits = await Promise.all(urls.map((url) => cache.match(url)));
  return hits.every((hit) => hit !== undefined);
}

/** Lädt Dateien vollständig in den Medienspeicher, damit sie offline abspielbar sind. */
export async function cacheFiles(urls: readonly string[]): Promise<void> {
  if (!offlineStorageAvailable()) {
    return;
  }
  const cache = await window.caches.open(MEDIA_CACHE);
  for (const url of urls) {
    if ((await cache.match(url)) === undefined) {
      await cache.add(url);
    }
  }
}

/** Entfernt alle zwischengespeicherten Daten und Medien. */
export async function clearOfflineData(): Promise<void> {
  if (!offlineStorageAvailable()) {
    return;
  }
  await Promise.all([window.caches.delete(DATA_CACHE), window.caches.delete(MEDIA_CACHE)]);
  try {
    for (const key of Object.keys(window.localStorage)) {
      if (key.startsWith('kochbuch.einkauf.')) {
        window.localStorage.removeItem(key);
      }
    }
  } catch {
    // Ohne Zugriff auf den Speicher gibt es auch nichts zu löschen.
  }
}
